<template>
  <b-dropdown-form
    class="py-1 dropdown-filter-form-n"
  >
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <b-form-group
      label="Dates"
    >
      <b-input-group>
        <flat-pickr
          v-model="serviceDateFilterValue"
          class="form-control"
          placeholder="Select Date Range"
          :config="flatPickrConfig"
        />
        <b-input-group-append is-text>
          <feather-icon
            icon="CalendarIcon"
            class="cursor-pointer"
            data-toggle
            size="18"
          />
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <hr class="dividerHR filter-divider">
    <b-form-group
      label="Request Type"
      @click.native.stop
    >
      <v-select
        v-model="requestTypeValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="name"
        multiple
        placeholder="Select an option"
        :options="requestTypeOptions"
        :selectable="option => !option.hasOwnProperty('category')"
        :clearable="false"
        :reduce="name => name._id"
      >
        <template #option="{ category, name, }">
          <div
            v-if="category"
            class="group"
          >
            {{ category }}
          </div>
          {{ name }}
        </template>
      </v-select>
    </b-form-group>
    <div v-if="$route.params.type != 'unassigned'">
      <hr class="dividerHR filter-divider">
      <b-form-group
        label="Assignee"
        @click.native.stop
      >
        <v-select
          v-model="assigneeValue"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="name"
          multiple
          placeholder="Select an option"
          :options="assigneeOptions"
          :clearable="false"
          :reduce="name => name._id"
        />
      </b-form-group>
      <hr class="dividerHR filter-divider">
      <b-form-group label="Service Request Assigned Status">
        <b-form-checkbox
          v-for="option in statusOptions"
          :key="option.value"
          v-model="statusFilterValue"
          :value="option.value"
          name="flavour-3a"
        >
          {{ option.label }}
        </b-form-checkbox>
      </b-form-group>
    </div>

    <hr class="dividerHR filter-divider">
    <b-form-group label="Payment Status">
      <b-form-checkbox
        v-for="option in paymentStatusOptions"
        :key="option.value"
        v-model="paymentStatusFilterValue"
        :value="option.value"
        name="flavour-3a"
      >
        {{ option.label }}
      </b-form-checkbox>
    </b-form-group>

    <div v-if="!['completed', 'pending'].includes($route.params.type)">
      <hr class="dividerHR filter-divider">
      <b-form-group label="Service Request Status">
        <b-form-checkbox
          v-for="option in requestStatusOptions"
          :key="option.value"
          v-model="requestStatusFilterValue"
          :value="option.value"
          name="flavour-3a"
        >
          {{ option.label }}
        </b-form-checkbox>
      </b-form-group>
    </div>
    <b-button
      variant="outline-primary"
      size="sm"
      class="mr-1"
      @click="clearFilter"
    >
      Clear All
    </b-button>
    <b-button
      variant="primary"
      size="sm"
      @click="applyFilter"
    >
      Apply Filter
    </b-button>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BButton, BRow, BCol, BInputGroup, BInputGroupAppend, BFormCheckbox,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import vSelect from 'vue-select'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BRow,
    BCol,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    flatPickr,
    vSelect,
  },
  props: {
    statusFilter: {
      type: [Array, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    paymentStatusFilter: {
      type: [Array, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    requestStatusFilter: {
      type: [Array, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    serviceDateFilter: {
      type: [String, null],
      default: null,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
    requestType: {
      type: [Array, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    requestTypeOptions: {
      type: Array,
      required: true,
    },
    assignee: {
      type: [Array, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    assigneeOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      serviceDateFilterValue: this.serviceDateFilter,
      statusFilterValue: JSON.parse(JSON.stringify(this.statusFilter)) || [],
      paymentStatusFilterValue: JSON.parse(JSON.stringify(this.paymentStatusFilter)) || [],
      requestStatusFilterValue: JSON.parse(JSON.stringify(this.requestStatusFilter)) || [],
      requestTypeValue: JSON.parse(JSON.stringify(this.requestType)) || [],
      assigneeValue: JSON.parse(JSON.stringify(this.assignee)) || [],
      flatPickrConfig: {
        wrap: true, mode: 'range', dateFormat: 'd/m/Y', enableTime: false, static: true, disableMobile: true,
      },
      paymentStatusOptions: [
        { label: 'Paid', value: 'Paid' },
        { label: 'Partially Paid', value: 'Partially Paid' },
        { label: 'Unpaid', value: 'Unpaid' },
        { label: 'FSP', value: 'FSP' },
        { label: 'N/A', value: 'N/A' },
      ],
      requestStatusOptions: [
        { label: 'Awaiting Approval', value: 'awaiting approval' },
        { label: 'Completed', value: 'completed' },
        { label: 'Pending', value: 'pending' },
      ],
    }
  },
  watch: {
    serviceDateFilter: {
      immediate: true,
      handler(val) {
        this.serviceDateFilterValue = val
      },
    },
    statusFilter: {
      immediate: true,
      handler(val) {
        this.statusFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    paymentStatusFilter: {
      immediate: true,
      handler(val) {
        this.paymentStatusFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    requestStatusFilter: {
      immediate: true,
      handler(val) {
        this.requestStatusFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    requestType: {
      immediate: true,
      handler(val) {
        this.requestTypeValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    assignee: {
      immediate: true,
      handler(val) {
        this.assigneeValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
  },
  methods: {
    showAgainDropdown() {
      if (this.serviceDateFilterValue) {
        this.$emit('emitShowFilter')
      }
    },
    applyFilter() {
      this.$emit('update:serviceDateFilter', this.serviceDateFilterValue)
      this.$emit('update:statusFilter', this.statusFilterValue)
      this.$emit('update:paymentStatusFilter', this.paymentStatusFilterValue)
      this.$emit('update:requestStatusFilter', this.requestStatusFilterValue)
      this.$emit('update:requestType', this.requestTypeValue)
      this.$emit('update:assignee', this.assigneeValue)

      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.serviceDateFilterValue = ''
      this.statusFilterValue = []
      this.paymentStatusFilterValue = []
      this.requestStatusFilterValue = []
      this.requestTypeValue = []
      this.assigneeValue = []
      this.$emit('update:serviceDateFilter', this.serviceDateFilterValue)
      this.$emit('update:statusFilter', this.statusFilterValue)
      this.$emit('update:paymentStatusFilter', this.paymentStatusFilterValue)
      this.$emit('update:requestStatusFilter', this.requestStatusFilterValue)
      this.$emit('update:requestType', this.requestTypeValue)
      this.$emit('update:assignee', this.assigneeValue)

      this.$emit('emitHideFilter')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
